export default {"src":"/_next/static/media/iniciatives.802343d7.svg","height":93,"width":108};